/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralSource
 */
export interface ReferralSource {
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    referral_date: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    referral_taken_by: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    admission_coordinator?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    physician_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    physician_contact?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    facility_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    relationship_to_patient?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    contact_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    contact_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    contact_work_phone?: string;
}

/**
 * Check if a given object implements the ReferralSource interface.
 */
export function instanceOfReferralSource(value: object): value is ReferralSource {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('referral_date' in value) || value['referral_date'] === undefined) return false;
    if (!('referral_taken_by' in value) || value['referral_taken_by'] === undefined) return false;
    return true;
}

export function ReferralSourceFromJSON(json: any): ReferralSource {
    return ReferralSourceFromJSONTyped(json, false);
}

export function ReferralSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralSource {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'referral_date': json['referral_date'],
        'referral_taken_by': json['referral_taken_by'],
        'admission_coordinator': json['admission_coordinator'] == null ? undefined : json['admission_coordinator'],
        'physician_name': json['physician_name'] == null ? undefined : json['physician_name'],
        'physician_contact': json['physician_contact'] == null ? undefined : json['physician_contact'],
        'facility_name': json['facility_name'] == null ? undefined : json['facility_name'],
        'relationship_to_patient': json['relationship_to_patient'] == null ? undefined : json['relationship_to_patient'],
        'contact_name': json['contact_name'] == null ? undefined : json['contact_name'],
        'contact_type': json['contact_type'] == null ? undefined : json['contact_type'],
        'contact_work_phone': json['contact_work_phone'] == null ? undefined : json['contact_work_phone'],
    };
}

export function ReferralSourceToJSON(json: any): ReferralSource {
    return ReferralSourceToJSONTyped(json, false);
}

export function ReferralSourceToJSONTyped(value?: ReferralSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'referral_date': value['referral_date'],
        'referral_taken_by': value['referral_taken_by'],
        'admission_coordinator': value['admission_coordinator'],
        'physician_name': value['physician_name'],
        'physician_contact': value['physician_contact'],
        'facility_name': value['facility_name'],
        'relationship_to_patient': value['relationship_to_patient'],
        'contact_name': value['contact_name'],
        'contact_type': value['contact_type'],
        'contact_work_phone': value['contact_work_phone'],
    };
}

